"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _ButtonStyled = _interopRequireDefault(require("./ButtonStyled"));
var _FontIcon = _interopRequireDefault(require("../Icons/FontIcon"));
var _Icon = _interopRequireDefault(require("../Icons/Icon"));
var _ScreenReaderText = _interopRequireDefault(require("../Typography/ScreenReaderText"));
var _Button = require("./Button");
var _mixins = require("../mixins");
var _helpers = require("../helpers");
var _excluded = ["iconSize", "font", "name", "rotate", "label", "align", "className", "hoverColor", "hoverTextColor", "automationHook"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var propTypes = _objectSpread(_objectSpread({}, _Button.buttonPropTypes), {}, {
  /** If You pass in this prop, a FontIcon component will be rendered instead of
   * the Icon component. This should be the font-family to be chosen from theme.
   * */
  font: _propTypes["default"].oneOf(["icons"]),
  /** Name of the icon */
  name: _propTypes["default"].string,
  /** Overwrite the icon size: pass in the desired iconSize: should exist in the
   * iconSizes object. */
  iconSize: _propTypes["default"].string,
  /** Number of degrees to rotate the icon by */
  rotate: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /** Text for the screen-reader */
  label: _propTypes["default"].string,
  /** Control the shape of the button */
  shape: _propTypes["default"].oneOf(["default", "round"]),
  /** Set a width for the button. It will be used for height as well, if height
   * is not passed in.  */
  w: _propTypes["default"].string,
  /** `width` is DEPRECATED, use `w`  */
  width: _propTypes["default"].string,
  /** Set a height for the button. It accepts "fieldHeight" as a valid option,
   * to make the button as tall as the default for fields (theme.fields.height)
   * */
  h: _propTypes["default"].string,
  /** `height` is DEPRECATED, use `h` */
  height: _propTypes["default"].string,
  /** The className to be passed to the button - needed to be extended by styled
   * components */
  className: _propTypes["default"].string,
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string,
  /** Makes a button that is it's "glued" to an input or another button on the
   * specified side by removing th rounded corners and border on the glued side.
   * It will also make the button the default height of an input
   * (theme.fields.height) */
  glued: _propTypes["default"].oneOf(["left", "right", "horizontal"])
});
exports.propTypes = propTypes;
var IconButtonStyled = (0, _styledComponents["default"])(_ButtonStyled["default"]).withConfig({
  displayName: "IconButton__IconButtonStyled",
  componentId: "sc-115ljw6-0"
})(["line-height:1;width:auto;height:auto;min-width:auto;flex-shrink:0;padding:", ";", ";", ";", " ", ";", " ", ""], function (props) {
  return props.theme.fields.pV;
}, _mixins.paddingMixin, function (props) {
  return (0, _mixins.marginMixin)(props, false);
}, function (props) {
  return props.w && (0, _styledComponents.css)(["padding:0;width:", ";height:", "};"], props.w === "fieldsHeight" ? props.theme.fields.height : props.w, props.h === "fieldsHeight" || props.w === "fieldsHeight" ? props.theme.fields.height : props.h ? props.h : props.w);
}, function (props) {
  return props.glued && (0, _styledComponents.css)(["width:", ";height:", ";padding:0;", ";", ""], props.theme.fields.height, props.theme.fields.height, _mixins.gluedMixin, props.w && (0, _styledComponents.css)(["width:", ";"], props.w));
}, function (props) {
  return props.h && (0, _styledComponents.css)(["height:", ";padding-top:0;padding-bottom:0;"], props.h === "fieldsHeight" ? props.theme.fields.height : props.h);
}, function (props) {
  return props.shape === "round" && (0, _styledComponents.css)(["border-radius:50%;"]);
});
var IconButton = function IconButton(_ref) {
  var _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? "base" : _ref$iconSize,
    font = _ref.font,
    name = _ref.name,
    rotate = _ref.rotate,
    label = _ref.label,
    align = _ref.align,
    className = _ref.className,
    hoverColor = _ref.hoverColor,
    hoverTextColor = _ref.hoverTextColor,
    automationHook = _ref.automationHook,
    rest = _objectWithoutProperties(_ref, _excluded);
  var width = rest.width,
    height = rest.height;
  (0, _helpers.useDeprecate)({
    width: width,
    height: height
  }, "IconButton");
  var IconComponent = font ? _FontIcon["default"] : _Icon["default"];
  return /*#__PURE__*/React.createElement(IconButtonStyled, _extends({
    className: className,
    $hoverTextColor: hoverTextColor,
    $hoverColor: hoverColor
  }, (0, _automationHooks.hook)(automationHook), rest), /*#__PURE__*/React.createElement(IconComponent, {
    size: iconSize,
    name: name,
    rotate: rotate,
    font: font
  }), /*#__PURE__*/React.createElement(_ScreenReaderText["default"], null, label));
};
IconButton.propTypes = propTypes;
var _default = IconButton;
exports["default"] = _default;